const common = {
  home: '官网首页',
  add: '新增',
  edit: '编辑',
  delete: '删除',
  detail: '详情',
  search: '搜索',
  reset: '重置',
  confirm: '确定',
  cancel: '取消',
  close: '关闭',
  save: '保存',
  logout: '退出登录',
  enabled: '启用',
  disabled: '禁用',
  yes: '是',
  no: '否',
  network_error: '网络异常，请稍后重试',
  language: '语言'
};

export default common;
